import { useEffect } from 'react';
import { installInlineKeyboardGuard } from '../../utils/ui/inlineKeyboardGuard';

/**
 * Mounts the global inline-field keyboard-reveal guard once at the app root.
 * Prevents the whole-app visual-viewport pan iOS triggers when focusing a
 * low-on-screen inline input (Cobrar/Estimates/Drafts search boxes) by
 * pre-scrolling the field's container so it's already visible above the
 * predicted keyboard line BEFORE focus lands. See `inlineKeyboardGuard.js`.
 */
export default function useInlineKeyboardGuard() {
  useEffect(() => installInlineKeyboardGuard(), []);
}
